import { z } from 'zod'

import { DEFAULT_LIMIT } from '@/components/ui/pagination/pagination.constants'
import { CommunicationTypeEnum } from '@/models'

// Note: Extend status to include 'All' which is only a UI concept
export const AnnouncementStatusFilterEnum = z.enum(['All', 'Scheduled', 'Completed'])
export type AnnouncementStatusFilter = z.infer<typeof AnnouncementStatusFilterEnum>

export const announcementsTableFiltersSchema = z.object({
  fromDate: z.coerce.number().optional(),
  limit: z.coerce.number().optional(),
  search: z.string().optional(),
  skip: z.coerce.number().optional(),
  status: AnnouncementStatusFilterEnum.optional(),
  toDate: z.coerce.number().optional(),
  type: z.array(CommunicationTypeEnum).optional(),
})

export type AnnouncementsTableFilters = z.infer<typeof announcementsTableFiltersSchema>

export const announcementsTableInitialFilters: AnnouncementsTableFilters = {
  fromDate: undefined,
  limit: DEFAULT_LIMIT,
  search: '',
  skip: 0,
  status: AnnouncementStatusFilterEnum.enum.All,
  toDate: undefined,
  type: [],
}
